import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../config/firebaseConfig";

const Updates = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showDetail, setShowDetail] = useState(null);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "notices"));
        const notices = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            title: data.title,
            description: data.description,
            imageUrl: data.imageUrl,
            fileType: data.fileType,
          };
        });
        setUpdates(notices);
      } catch (error) {
        setUpdates([]);
      }
      setLoading(false);
    };
    fetchNotices();
  }, []);

  // Swipe up/next logic (loop)
  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % updates.length);
  };
  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + updates.length) % updates.length);
  };

  // Card click to view detail
  const handleCardClick = (idx) => {
    setShowDetail(updates[idx]);
  };

  // Close detail modal
  const closeDetail = () => setShowDetail(null);

  return (
    <div className="w-full rounded-[1.5rem] bg-slate-50/90 p-4 sm:p-5">
      <div className="mb-5 flex items-center justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-blue-600">
            School Noticeboard
          </p>
          <h3 className="mt-2 text-2xl font-bold text-slate-950 sm:text-3xl">
            Latest Updates
          </h3>
        </div>
        <div className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
          Live
        </div>
      </div>

      <div className="w-full">
        {loading ? (
          <div className="rounded-[1.5rem] border border-slate-200 bg-white px-6 py-10 text-center text-sm font-medium text-blue-600 shadow-sm animate-pulse">
            Loading...
          </div>
        ) : updates.length === 0 ? (
          <div className="rounded-[1.5rem] border border-slate-200 bg-white p-8 text-center text-slate-500 shadow-sm">
            No updates available.
          </div>
        ) : (
          <div className="relative w-full">
            {/* Card */}
            <div
              className="cursor-pointer transition-transform duration-300 hover:-translate-y-1"
              onClick={() => handleCardClick(activeIndex)}
            >
              <div className="flex flex-col items-center gap-4 rounded-[1.5rem] border border-slate-200 bg-white p-5 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
                <div className="flex flex-wrap items-center justify-center gap-2 text-center">
                  <span className="text-lg font-bold text-slate-900">
                    {updates[activeIndex].title}
                  </span>
                  {updates[activeIndex].fileType === "pdf" && (
                    <span className="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-semibold text-red-600">
                      PDF
                    </span>
                  )}
                  {updates[activeIndex].fileType === "image" && (
                    <span className="inline-flex items-center rounded-full bg-emerald-50 px-2 py-1 text-xs font-semibold text-emerald-600">
                      Image
                    </span>
                  )}
                </div>
                <div className="max-w-md text-center text-sm leading-6 text-slate-600 sm:text-base">
                  {updates[activeIndex].description}
                </div>
                {updates[activeIndex].imageUrl &&
                  updates[activeIndex].fileType === "image" && (
                    <img
                      src={updates[activeIndex].imageUrl}
                      alt={updates[activeIndex].title}
                      className="mx-auto h-44 w-44 rounded-2xl border border-slate-200 object-cover shadow-md"
                    />
                  )}
                {updates[activeIndex].imageUrl &&
                  updates[activeIndex].fileType === "pdf" && (
                    <a
                      href={updates[activeIndex].imageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 transition hover:bg-blue-100 hover:text-blue-900"
                    >
                      <svg
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="inline-block"
                      >
                        <path d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6zm7 1.5V8h5.5L13 3.5zM6 4h6v5a1 1 0 0 0 1 1h5v10H6V4zm7 10v2h-2v-2h2zm-4 0v2H7v-2h2z" />
                      </svg>
                      View PDF
                    </a>
                  )}
              </div>
            </div>
            {/* Swipe Buttons */}
            <div className="flex justify-between mt-6">
              <button
                onClick={handlePrev}
                className="rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-700"
              >
                Prev
              </button>
              <button
                onClick={handleNext}
                className="rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700"
              >
                Next
              </button>
            </div>
            {/* <div className="mt-2 text-center text-xs text-gray-500">
              Swipe up/down or use buttons to browse updates
            </div> */}
          </div>
        )}
      </div>

      {/* Detail Modal */}
      {showDetail && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm"
          onClick={closeDetail}
        >
          <div
            className="relative flex w-full max-w-md flex-col items-center rounded-[1.5rem] bg-white p-8 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeDetail}
              className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition hover:bg-red-600 hover:text-white"
              aria-label="Close"
            >
              ×
            </button>
            <h2 className="mb-2 text-center text-2xl font-bold text-slate-950">
              {showDetail.title}
            </h2>
            <div className="mb-4 text-center text-sm leading-6 text-slate-600 sm:text-base">
              {showDetail.description}
            </div>
            {showDetail.imageUrl && showDetail.fileType === "image" && (
              <img
                src={showDetail.imageUrl}
                alt={showDetail.title}
                className="mb-2 h-56 w-56 rounded-2xl border border-slate-200 object-cover shadow-md"
              />
            )}
            {showDetail.imageUrl && showDetail.fileType === "pdf" && (
              <a
                href={showDetail.imageUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 font-semibold text-blue-700 transition hover:bg-blue-100 hover:text-blue-900"
              >
                <svg
                  width="32"
                  height="32"
                  fill="currentColor"
                  className="inline-block"
                >
                  <path d="M6 2a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8l-8-6H6zm9 2.5V8h7.5L15 4.5zM6 4h8v5a1 1 0 0 0 1 1h7v18H6V4zm9 16v2h-2v-2h2zm-4 0v2H9v-2h2z" />
                </svg>
                View PDF
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Updates;
